import { render, staticRenderFns } from "./ButtonDropdown.vue?vue&type=template&id=71c2f308"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports